export default "__VITE_ASSET__B6P02FQP__"